export default __webpack_public_path__ + "static/media/scan-barcode.35c069c4.gif";